var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 35,
    viewBox: "0 0 42 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.6667 -38.5H-25.6667C-30.8213 -38.5 -35 -34.3213 -35 -29.1667V64.1667C-35 69.3214 -30.8213 73.5 -25.6667 73.5H67.6667C72.8213 73.5 77 69.3214 77 64.1667V-29.1667C77 -34.3213 72.8213 -38.5 67.6667 -38.5Z",
    stroke: "#D9D9D9",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.911 1.07031L15.7307 1.08304C15.3752 1.13352 15.0543 1.33174 14.852 1.63312L11.8332 6.12587H5.72917C3.15184 6.12587 1.0625 8.2007 1.0625 10.7601V29.2972C1.0625 31.8566 3.15184 33.9314 5.72917 33.9314H36.2746C38.852 33.9314 40.9413 31.8566 40.9413 29.2972V10.7601L40.9328 10.4778C40.7859 8.04986 38.7565 6.12587 36.2746 6.12587H30.1689L27.1518 1.63312C26.9157 1.28151 26.5183 1.07031 26.0928 1.07031H15.911ZM16.5915 3.59809H25.4106L28.4278 8.09084C28.6638 8.44245 29.0612 8.65365 29.4867 8.65365H36.2746C37.4461 8.65365 38.3958 9.59676 38.3958 10.7601V29.2972C38.3958 30.4606 37.4461 31.4037 36.2746 31.4037H5.72917C4.55765 31.4037 3.60795 30.4606 3.60795 29.2972V10.7601C3.60795 9.59676 4.55765 8.65365 5.72917 8.65365H12.517L12.6973 8.64093C13.0528 8.59044 13.3737 8.39222 13.576 8.09084L16.5915 3.59809Z",
    fill: "#4D4D4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.002 11.1816C16.5503 11.1816 12.9414 14.7654 12.9414 19.1863C12.9414 23.6071 16.5503 27.1909 21.002 27.1909C25.4538 27.1909 29.0626 23.6071 29.0626 19.1863C29.0626 14.7654 25.4538 11.1816 21.002 11.1816ZM21.002 13.7094C24.0479 13.7094 26.5172 16.1615 26.5172 19.1863C26.5172 22.2111 24.0479 24.6631 21.002 24.6631C17.9561 24.6631 15.4869 22.2111 15.4869 19.1863C15.4869 16.1615 17.9561 13.7094 21.002 13.7094Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCamera);
export default __webpack_public_path__ + "static/media/upload-camera.eb939bbd42cf7e1385a5b92064b9bc53.svg";
export { ForwardRef as ReactComponent };